/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".faq-question-container[_ngcontent-%COMP%]{border-bottom:1px solid #dcdcdc;padding:10px 8px}.header[_ngcontent-%COMP%]{display:flex;align-items:center}.header[_ngcontent-%COMP%], .show-cursor[_ngcontent-%COMP%]{cursor:pointer}.green-dot[_ngcontent-%COMP%]{display:block;width:7px;height:7px;border-radius:50%;background-color:#8feac3;margin-right:20px}.flip-arrow[_ngcontent-%COMP%]{-webkit-transform:rotateZ(180deg);transform:rotateZ(180deg)}"];
export { styles as styles };
